<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="missionList">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 任务清单
        </span>
        <div class="w_normalNav">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
        </div>
        <div class="searchForm1">
          <searchForm :items="items" :formPlus="form_jsgl" ref="searchForm_jsgl">
            <template slot="last">
              <el-form-item label="计划名称">
                <el-input placeholder="请输入计划名称" v-model="seefrom.name"></el-input>
              </el-form-item>
              <el-form-item label="管理层级">
                <el-select placeholder="请选择" v-model="seefrom.ma_id">
                  <el-option
                    v-for="item in Hierarchy"
                    :key="item.id"
                    :value="item.id"
                    :label="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="处理人">
                <el-input placeholder="请输入处理人" v-model="seefrom.userName"></el-input>
              </el-form-item>
              <el-form-item label="任务编号">
                <el-input placeholder="请输入任务编号" v-model="seefrom.number"></el-input>
              </el-form-item>
              <br />
              <el-form-item label="任务状态">
                <el-select placeholder="请选择" v-model="seefrom.status">
                  <el-option
                    v-for="item in missionStatus"
                    :key="item.id"
                    :value="item.id"
                    :label="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="开始时间">
                  <el-date-picker placeholder="请选择开始时间" v-model="seefrom.time"></el-date-picker>
              </el-form-item>-->
            </template>
          </searchForm>
        </div>
        <div class="tableWrapper" v-loading="!showTable">
          <!-- 后端分页 -->
          <easyTable
            apiUrl="operation/tasktab/findAll"
            :parent="self"
            :config="config"
            :other="other"
            ref="missionList"
          >
            <template slot="last">
              <el-table-column label="状态" width="120">
                <template slot-scope="scope">
                  <span v-if="scope.row.status === 0">待处理</span>
                  <span v-if="scope.row.status === 1">已处理</span>
                  <span v-if="scope.row.status === 2">已过期</span>
                </template>
              </el-table-column>
            </template>
          </easyTable>
        </div>
        <!-- dialog -->
        <el-dialog
          class="editDialog"
          :visible.sync="displayForm"
          :title="title"
          :close-on-click-modal="false"
        >
          <el-form class="w_mission">
            <el-form-item label="计划名称：" prop="name">
              <span>{{this.Details.programName}}</span>
            </el-form-item>
            <el-form-item label="任务内容：" prop="remark">
              <span>{{this.Details.content}}</span>
            </el-form-item>
            <el-form-item label="处理详情：" prop="hierarchy">
              <span>{{this.Details.remark}}</span>
            </el-form-item>
            <el-form-item label="任务状态：" prop="cycle">
              <span v-if="this.Details.status === 0">待处理</span>
              <span v-if="this.Details.status === 1">已处理</span>
              <span v-if="this.Details.status === 2">已过期</span>
            </el-form-item>
          </el-form>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //详情
      Details: [],
      tabName: "missionList",
      loading: true,
      form_jsgl: {},
      displayForm: false,
      showTable: true,
      other: {},
      items: [],
      loadingStatus: false,
      //弹框标题
      title: "",
      status: "",
      seefrom: {
        name: "",
        ma_id: "",
        userName: "",
        number: "",
        status: ""
      },
      //任务状态
      missionStatus: [
        { id: "0", label: "待处理" },
        { id: "1", label: "已处理" },
        { id: "2", label: "已过期" }
      ],
      Hierarchy: [],
    };
  },
  computed: {
    self() {
      return this;
    },
    config() {
      return [
        {
          prop: "number",
          label: "任务编号"
        },
        {
          prop: "programName",
          label: "计划名称"
        },
        {
          prop: "maName",
          label: "管理层级"
        },
        {
          prop: "userName",
          label: "处理人"
        },
        {
          prop: "content",
          label: "任务内容"
        },
        {
          prop: "create_time",
          label: "任务生成时间"
        },
        // {
        //   prop: "now_period",
        //   label: "当前周期"
        // },
        // {
        //   prop: "period",
        //   label: "周期区间"
        // }
      ];
    },
    dt() {
      return dt.map(({ label }) => label);
    }
  },
  components: {
    normalNav: () => import("public/normalNav"),
    searchForm: () => import("public/searchForm"),
    easyTable: () => import("public/easyTable")
  },
  methods: {
    //搜索
    subSeefrom() {
      this.other = this.seefrom;
      this.$nextTick(this.$refs.missionList.getData);
    },
    //重置
    reset() {
      this.seefrom.name = "";
      this.seefrom.ma_id = "";
      this.seefrom.userName = "";
      this.seefrom.number = "";
      this.seefrom.status = "";
    },
    //详情
    see(index, row) {
      this.title = "任务详情";
      this.displayForm = true;
      this.Details = row;
      //console.log(row)
    }
  },
  created() {
    //管理层级
    this.$axiosget("operation/management/findAll", {
      params: {
        pageNum: 1,
        pageSize: 1000
      }
    }).then(res => {
      this.Hierarchy = res.data.data.list;
      //console.log(this.Hierarchy, "管理层级");
    });
  }
};
</script>

<style lang="less" scoped>
.w_normalNav {
  padding-top: 10px;
  height: 52px;
  position: absolute;
  top: -52px;
  right: 32px;
  z-index: 99;
}
.el-textarea__inner {
  border: 1px solid #3d4963;
  border-radius: 0;
  width: 310px;
  background: transparent;
  color: #cacaca;
}
.el-input__inner:focus {
  border: 1px solid #3587c7;
}
.w_mission {
  margin-bottom: 30px;
  .el-form-item__content {
    width: 310px;
    span {
      display: inline-block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/mission/missionList.vue